export default function ArrowDown({ width = 15, height = 15 }) {
	return (
		<svg overflow="visible" preserveAspectRatio="none" viewBox="0 0 24 24" width={ width } height={ height }>
			<g>
				<path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z" vectorEffect="non-scaling-stroke"/>
			</g>
		</svg>
	);
}
